import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';



import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BindComponentService } from '../utils/bind.component.service';
import { CommonService } from './common.service';
/**
 * @author Wesley Mascarenhas
 * @version $Id: administration.service.ts 81701 2018-03-08 23:46:04Z thiago.h.neri $
 */
@Injectable()
export class AdministrationService extends CommonService {

  private localURL: string;
  private ADMINSTRATION_PATH: string = '/datapackusermanager';


  constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService) {
    super(http, modalService, bindComponent);
    this.localURL = this.baseURL + this.ADMINSTRATION_PATH;
  }    

  public edit(data: any) {
    return this.convertResponse(this.httpPost(this.localURL, data));
  }

  public remove(data: any) {
    return this.convertResponse(this.httpPost(this.localURL, data));
  }

  public listAdmins(startRow: number, fetchSize: number) {
    let url = this.localURL + '?action=list';
    if(startRow >= 0) {
      url += '&startRow=' + startRow;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));
  }

  public getAbbreviatedData(serviceName: string, contractNumber: string) {
    return this.convertResponse(this.httpPost(this.localURL,{action:'getAbbreviatedData',serviceName:serviceName,contractNumber:contractNumber}));
  }
  public insertOrUpdateMember(data: any) {
    return this.convertResponse(this.httpPost(this.localURL, data));
  }
  public removeMember(data: any) {
    return this.convertResponse(this.httpPost(this.localURL, data));
  }
}


// WEBPACK FOOTER //
// ./src/app/services/administration.service.ts